import * as React from "react"
import MapBlock from "../../blocks/mapBlock"
import Section from "../../../../core/layout/main/section/Section"
import Button from "../../../common/blocks/button/Button"
import { getHoraireData } from "../../../../../utils/horairesLib"
import * as classNames from "./CtxDepartementAgencesSection.module.scss"

const CtxDepartementAgencesSection = ({
  regionName,
  agenciesData,
}) => {
  
  const horairesData = getHoraireData()

  return (
    <>
      <Section>
        <div
          class="spacer"
          style={{ height: "120px" }}
        ></div>
        <div
          class="container"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div style={{ width: "100%" }}>
            <h2>
              {agenciesData.length > 1
                ? `${agenciesData.length} agences Paritel en ${regionName}`
                : `1 agence Paritel en ${regionName}`}
            </h2>
            <div className="spacer height-40"></div>
            <p>
              Prenez RDV avec un de nos experts afin de bénéficier d’un bilan
              gratuit.
              <br />
              Nos conseillers se déplacent directement sur votre lieu de
              travail.
            </p>
            <div className="spacer height-40"></div>
            <div
              style={{
                paddingInline: "calc(var(--spacing) * 4)",
                paddingBlock: "calc(var(--spacing) * 3)",
                display: "flex",
                flexDirection: "column",
                gap: "calc(var(--spacing) * 1)"
              }}
            >
              {agenciesData.map((a) => {
                return (
                  <div
                    className={classNames.card_panel+' card'} 
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        gap: "calc(var(--spacing) * 1)"
                      }}
                    >
                      <h3 style={{ flexGrow: 1 }}>{a.attributes.name}</h3>
                      <time
                        itemprop="openingHours"
                        datetime="Mo-Fr 09:00-17:00"
                        className="flex align-items-center gap-2"
                        style={{
                          color: horairesData.isOpen
                            ? "var(--valid-color)"
                            : "var(--invalid-color)",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="8"
                            cy="8"
                            r="8"
                            fill={
                              horairesData.isOpen
                                ? "var(--valid-color)"
                                : "var(--invalid-color)"
                            }
                          ></circle>
                        </svg>
                        {horairesData.horaireText}
                      </time>
                      <Button to={a.attributes.autoRoute}>Voir l'agence</Button>
                    </div>
                    <div
                      className={classNames.card_buttons_panel} 
                    >
                      <Button
                        aspect="classique"
                        color="primary"
                        size="medium"
                        to={"tel:" + a.attributes.telephoneReal}
                        style={{ width: "100%" }}
                      >
                        {a.attributes.telephone}
                      </Button>
                      <Button
                        aspect="contrastant"
                        color="primary"
                        size="medium"
                        style={{ width: "100%" }}
                        ctalink={{
                          type: "site",
                          site: "sl",
                          subType: "collection",
                          collectionName: "pop-ins",
                          itemId: "16",
                          popIn: undefined,
                          context1: "baby-menu",
                          itemData: {
                            attributes: { autoRoute: "/pop-in/rendez-vous-1" },
                          },
                        }}
                        asModal
                      >
                        Prendre rendez-vous
                      </Button>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className={classNames.map_panel} style={{ width: "100%", height:'100%' }}>
          <MapBlock agenciesList={agenciesData} />
          </div>
        </div>
        <div
          class="spacer"
          style={{ height: "120px" }}
        ></div>
      </Section>
    </>
  )
}

export const name = "CtxDepartementAgencesSection"

export const init = (componentData, pageContext) => {

  const regionByDepSlug = {}
  for(const r of pageContext.regionsDepartementsData) {
    for(const d of r.attributes.departements.data) {
      regionByDepSlug[d.attributes.slug] = r
    }
  }
  const agenciesByRegionSlug = {}

  for (const agencyData of pageContext.slAgenciesData) {
    const depSlug = agencyData.attributes.locationDepartement.data.attributes.slug    
    const regionSlug = regionByDepSlug[depSlug].attributes.slug
    if( agenciesByRegionSlug.hasOwnProperty(regionSlug)) {
      agenciesByRegionSlug[regionSlug].push(agencyData)
    } else {
      agenciesByRegionSlug[regionSlug] = [agencyData]
    }
  }

  return (
    <CtxDepartementAgencesSection
      key={componentData.id}
      subTitle={componentData.subTitle}
      regionName={pageContext.itemData.region.name}
      agenciesData={agenciesByRegionSlug[regionByDepSlug[pageContext.itemData.attributes.slug].attributes.slug]}
    />
  )
}

export default CtxDepartementAgencesSection
